<template>
    <div class="home_wrapper">
        <home-carousel></home-carousel>
        <home-introduce></home-introduce>
        <news-bulletin></news-bulletin>
        <Business-Development></Business-Development>
        <party-building></party-building>
        <!-- <div style="width:1147px;margin:0 auto">
          <yuu-link :linksList="linkList"></yuu-link>
        </div> -->
    </div>
</template>

<script>
import HomeIntroduce from "./components/Introduce.vue";
import NewsBulletin from "./components/Newsbulletin.vue";
import BusinessDevelopment from "./components/Businessdevelopment.vue";
import PartyBuilding from "./components/Partybuilding.vue";
import HomeCarousel from "./components/Carousel.vue";
import YuuLink from "../../components/Links.vue";
export default {
    components: {
        HomeIntroduce,
        NewsBulletin,
        BusinessDevelopment,
        PartyBuilding,
        HomeCarousel,
        YuuLink,
    },
    data() {
        return {
            linkList: [
                {
                    text: "人民网",
                    url: "http://www.people.com.cn/",
                },
                {
                    text: "共产党员网",
                    url: "https://www.12371.cn/",
                },
                {
                    text: "中国共产党新闻网",
                    url: "http://cpc.people.com.cn/",
                },
                {
                    text: "学习强国",
                    url: "https://www.xuexi.cn/",
                },
            ],
        };
    },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/Home/Home.vue